import loadable from "./lazy";

export default loadable;
